import { useQuery } from 'react-query';

import {
  interviewCountsKey,
  errorMessage,
  interviewCountsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetInterviewCountsProps = {
  enabled: boolean;
  selectedCompanyId?: string | number;
};

export const useGetInterviewCounts = ({
  enabled,
  selectedCompanyId,
}: useGetInterviewCountsProps) => {
  const { data: interviewCount } = useQuery({
    queryKey: [interviewCountsKey, selectedCompanyId],
    enabled: Boolean(enabled),
    queryFn: () => {
      return axiosInstance
        .get(
          selectedCompanyId
            ? `${interviewCountsRoute}?company_id=${selectedCompanyId}`
            : interviewCountsRoute,
        )
        .then((res) => res.data);
    },

    onError: () => {
      console.error(errorMessage);
    },
  });

  return {
    interviewCount,
  };
};
